export const isComponent = (intendedUseCode) => {
  // Only 081.007 (components only) should auto-trigger CPT = true.
  // 081.001 (standard EUL) and 081.008 (combination product) should NOT
  // auto-set CPT — it should only be set based on IOR's CPT indicator.
  // See: V2252832762
  return ['081.007'].includes(intendedUseCode);
};

export const isImportForExport = (intendedUseCode) => {
  return ['170.000', '970.000', '970.001'].includes(intendedUseCode);
};

export const isKit = (intendedUseCode) => {
  return ['081.003', '081.004'].includes(intendedUseCode);
};
